import React from "react";
import { StyleSheet, View, TouchableOpacity, Animated } from "react-native";
import Fonts from "@microdoing/shared/constants/Fonts";
import theme from "app/Theme/Theme";

const styles = StyleSheet.create({
  tab: {
    position: "relative",
    marginRight: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  tabText: {
    ...Fonts.montserrat.bold,
    fontWeight: "700",
  },
  notification: {
    backgroundColor: theme.colors["system.red.900"],
    width: 8,
    height: 8,
    borderRadius: 4,
    position: "absolute",
    top: 5,
    right: -12,
  },
});

const TopTab = ({
  label,
  isFocused,
  options,
  onPress,
  onLongPress,
  measureWidth,
  animatedTextStyle = {},
  hasNotification = true,
  opacity,
  testID = undefined,
}) => {
  return (
    <TouchableOpacity
      hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
      onLayout={measureWidth}
      accessibilityRole="button"
      accessibilityStates={isFocused ? ["selected"] : []}
      accessibilityLabel={options.tabBarAccessibilityLabel}
      onPress={onPress}
      style={styles.tab}
      testID={testID}
    >
      <Animated.Text
        maxFontSizeMultiplier={1}
        style={[styles.tabText, { opacity }]}
      >
        {label}
      </Animated.Text>
      {!!hasNotification && <View style={styles.notification} />}
    </TouchableOpacity>
  );
};

export default TopTab;
